import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import styles from "./faq-page.module.scss";

// Same entries as the mobile app's FAQ page: account.faqQ{n} / account.faqA{n}.
const FAQ_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17] as const;

const ChevronIcon: React.FC = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
		<path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const FaqPage: React.FC = () => {
	const { t } = useTranslation();
	const [openItems, setOpenItems] = useState<Set<number>>(new Set());

	const toggleItem = (index: number) => {
		setOpenItems(prev => {
			const next = new Set(prev);
			if (next.has(index)) next.delete(index);
			else next.add(index);
			return next;
		});
	};

	return (
		<CustomerPageLayout title={t("account.faqTitle")} showBackButton isScrollable>
			<div className={styles.card}>
				{FAQ_NUMBERS.map((n, index) => {
					const isOpen = openItems.has(index);
					return (
						<div key={n} className={styles.item}>
							<button
								type="button"
								className={styles.questionRow}
								onClick={() => toggleItem(index)}
								aria-expanded={isOpen}
							>
								<span className={styles.question}>{t(`account.faqQ${n}`)}</span>
								<span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""}`}>
									<ChevronIcon />
								</span>
							</button>
							<div className={`${styles.answerWrap} ${isOpen ? styles.answerWrapOpen : ""}`}>
								<p className={styles.answer}>{t(`account.faqA${n}`)}</p>
							</div>
						</div>
					);
				})}
			</div>
		</CustomerPageLayout>
	);
};

export default FaqPage;
